export function RatingDisplay({ value }: { value: number | null }) {
  if (value === null) {
    return <span className="text-muted-foreground font-mono text-lg">N/A</span>
  }

  return (
    <div className="inline-flex items-baseline">
      <span className="font-mono text-2xl font-bold">{value.toFixed(1)}</span>
      <span className="font-mono text-sm font-bold opacity-50">/5</span>
    </div>
  )
}
